import apiClient from "@/app/api/client";
import { equipmentTypeEndpoints, replaceParams } from "@/app/api/endpoints";
import type {
	CreateEquipmentTypeRequest,
	EquipmentType,
	EquipmentTypeListParams,
	EquipmentTypePaginatedResponse,
	SuccessResponse,
	UpdateEquipmentTypeRequest,
} from "../types";

export const equipmentTypeService = {
	async list(params?: EquipmentTypeListParams): Promise<EquipmentTypePaginatedResponse> {
		const response = await apiClient.get<EquipmentTypePaginatedResponse>(
			equipmentTypeEndpoints.list,
			{ params }
		);
		return response.data;
	},

	async getById(id: string): Promise<EquipmentType> {
		const url = replaceParams(equipmentTypeEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<EquipmentType>>(url);
		return response.data.data;
	},

	async create(data: CreateEquipmentTypeRequest): Promise<EquipmentType> {
		const response = await apiClient.post<SuccessResponse<EquipmentType>>(
			equipmentTypeEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(id: string, data: UpdateEquipmentTypeRequest): Promise<EquipmentType> {
		const url = replaceParams(equipmentTypeEndpoints.update, { id });
		const response = await apiClient.put<SuccessResponse<EquipmentType>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(equipmentTypeEndpoints.delete, { id });
		await apiClient.delete(url);
	},
};
